export default "__VITE_ASSET__IBGrXKAN__"